/* =========================================================
   NVEDA — PDP FREE GIFT LINE (standalone)

   A single presentation-only line under the product price:
     "Free gift on every order above ₹999"

   Independent of the cart script. Safe to add or remove on its
   own — it never touches the cart, fetch, or checkout.

   INSTALL
   1. Upload to: assets/nveda-pdp-gift-line.js
   2. In layout/theme.liquid, before </body>:
      <script src="{{ 'nveda-pdp-gift-line.js' | asset_url }}" defer="defer"></script>
   TO REMOVE: delete that one line. Nothing else is affected.
   ========================================================= */

(function () {
  'use strict';

  window.__NVEDA_PDP_GIFT__ = 'standalone-v2';

  /* ---------- CONFIG ---------- */
  const CFG = {
    THRESHOLD_TEXT: '₹999',   // shown in the line; display only
    TEXT: 'Free gift on every order above {threshold}',
    SHOW_ICON: true,          // set false to drop the 🎁 emoji
    BG: '#2e7d32',            // mid green fill
    TEXT_COLOR: '#ffffff',    // text on the band
    FLASH: true,              // pulse a few times on load to catch the eye

    // First matching selector becomes the mount; line inserts AFTER it.
    // Scoped to the main product form so Similar-Products prices are ignored.
    ANCHORS: ['.m-price', '.product__price', '[data-product-price]']
  };

  /* ---------- STYLES ---------- */
  function injectCss() {
    if (document.getElementById('nveda-pdp-gift-css')) return;
    const st = document.createElement('style');
    st.id = 'nveda-pdp-gift-css';
    st.textContent = `
      .nveda-pdp-gift {
        display: flex; align-items: center; gap: 9px;
        margin: 12px 0 4px; padding: 11px 15px; border-radius: 6px;
        background: ${CFG.BG}; color: ${CFG.TEXT_COLOR};
        font-size: 14px; line-height: 1.35;
        box-shadow: 0 1px 4px rgba(46,125,50,.28);
      }
      .nveda-pdp-gift b { font-weight: 700; }
      .nveda-pdp-gift__ico { flex: 0 0 auto; font-size: 16px; }
      .nveda-pdp-gift--flash { animation: nvedaGiftPulse 1s ease 3; }
      @keyframes nvedaGiftPulse {
        0%,100% { box-shadow: 0 1px 4px rgba(46,125,50,.28); }
        50%     { box-shadow: 0 0 0 4px rgba(46,125,50,.35); }
      }
      @media (prefers-reduced-motion: reduce) {
        .nveda-pdp-gift--flash { animation: none; }
      }
    `;
    (document.head || document.documentElement).appendChild(st);
  }

  /* ---------- ANCHOR ---------- */
  // The page has many price nodes (Similar Products, upsells). Scope to
  // the main Add-to-Cart form first, then fall back to a raw selector.
  function findAnchor() {
    const form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.m-product-form');

    if (form) {
      let scope = form;
      for (let i = 0; i < 4 && scope.parentElement; i++) {
        scope = scope.parentElement;
        for (const sel of CFG.ANCHORS) {
          const hit = scope.querySelector(sel);
          if (hit) return hit;
        }
      }
    }
    for (const sel of CFG.ANCHORS) {
      const hit = document.querySelector(sel);
      if (hit) return hit;
    }
    return null;
  }

  /* ---------- RENDER ---------- */
  function render() {
    // Product pages only
    if (!/\/products\//.test(window.location.pathname)) return;
    if (document.getElementById('nveda-pdp-gift')) return;

    const anchor = findAnchor();
    if (!anchor) return;

    injectCss();

    const msg = CFG.TEXT.replace(
      '{threshold}', '<b>' + CFG.THRESHOLD_TEXT + '</b>'
    );

    const box = document.createElement('div');
    box.id = 'nveda-pdp-gift';
    box.className = 'nveda-pdp-gift';
    box.innerHTML =
      (CFG.SHOW_ICON ? '<span class="nveda-pdp-gift__ico">\u{1F381}</span>' : '') +
      '<span>' + msg + '</span>';

    if (CFG.FLASH) box.classList.add('nveda-pdp-gift--flash');

    anchor.insertAdjacentElement('afterend', box);
  }

  /* ---------- BOOT ---------- */
  function boot() {
    render();
    // Some themes swap the price node after load (variant JS, quick view).
    // Retry a few times, then give up. Cheap and self-limiting.
    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      if (document.getElementById('nveda-pdp-gift') || tries > 6) {
        clearInterval(t);
        return;
      }
      render();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();